import * as config from '@/config.json'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import PaginationNav from '@/components/PaginationNav.vue'
import PaginationMobile from '@/components/PaginationMobile.vue'
import axios from 'axios'

export default {
  name: 'DevicesList',
  components: {
    Loading,
    PaginationNav,
    PaginationMobile
  },
  data() {
    return {
      isLoading: false,
      isInitializing: false,
      isLoadingData: false,
      devices: [],
      pos: [],
      posBySite: [],
      recognitionGateways: [],
      selectedFilterOption: 1,
      searchTerm: '',
      selectedOptionSite: null,
      optionsSite: [],
      selectedOptionCompany: null,
      optionsCompany: [],
      token: null,
      page: 1,
      currentPage: 1,
      perPage: 8,
      isBusy: false,
      filterOptions: [
        { value: 1, text: 'ID Dispositivo' },
        { value: 2, text: 'Nome Dispositivo' }
      ],
      tabIndex: 0,
      optionWeighingMachine: [],
      posId: null,
      posNumber: null,
      sitefParams: '',
      sitefAllowedTransactions: '',
      sitefOtp: '',
      selectedSitefLib: null,
      optionSitefLib: [
        { value: 0, text: 'Selecione...' },
        { value: 1, text: 'clisitef' },
        { value: 2, text: 'plugpag' },
        { value: 3, text: 'stone' },
        { text: 'msitef', value: 4 }
      ],
      sitefExternalCom: '',
      sitefIsDoubleValidation: 0,
      timerInteraction: 0,
      selectedWeighingMachine: null,
      showUserPassword: false,
      allowEditSitef: false,
      isCollapseOpen: false,
      typeInput: 'password',
      sitefDailyToken: '',
      showPasswordSitef: false,
      DailyToken: '',
      deviceId: null,
      deviceDescription: '',
      deviceType: '',
      deviceModel: '',
      deviceSerialNumber: '',
      deviceSiteName: '',
      deviceHomeAssistantEntityId: '',
      deviceDelayTime: '',
      posSiteName: '',
      posType: '',
      posModel: '',
      posSerialNumber: '',
      posHomeAssistantEntityId: '',
      posDelayTime: '',
      posVersion: '',
      posToken: '',
      posExpiryAt: '',
      posLastStatus: '',
      posTimeFromLastComunication: '',
      posIsError: '',
      posInactive: false,
      posWeighingMachineId: '',
      posWeighingMachineConfiguration: {
        labelType: '',
        codSize: '',
        prefix: ''
      },
      facialId: null,
      facialDescription: '',
      facialType: '',
      facialModel: '',
      facialSerialNumber: '',
      facialSiteName: '',
      facialHomeAssistantEntityId: '',
      facialDelayTime: '',

      posSearchTerm: '',
      facialSearchId: '',
      facialSearchToken: '',

      paginationDevices: [],
      paginationPos: [],
      paginationFacial: [],
      rowsPerPage: 8,
      paginationRange: 11,

      deviceToLink: {},
      linkType: 'site',
      linkTypeOptions: [
        { value: 'site', text: 'Site' },
        { value: 'pos', text: 'POS' }
      ],
      selectedLinkSite: null,
      selectedLinkPos: null,
      posOptions: [],
      isLinkModalOpen: false
    }
  },

  watch: {
    linkType() {
      this.selectedLinkSite = null
      this.selectedLinkPos = null
    }
  },

  computed: {
    hasDevices() {
      return this.devices && this.devices.length > 0
    },

    hasPos() {
      return this.pos && this.pos.length > 0
    },

    hasFacial() {
      return this.recognitionGateways && this.recognitionGateways.length > 0
    },

    showDevicesEmptyMessage() {
      return this.selectedOptionCompany && !this.isBusy && !this.hasDevices
    },

    showPosEmptyMessage() {
      return this.selectedOptionCompany && !this.isBusy && !this.hasPos
    },

    showFacialEmptyMessage() {
      return this.selectedOptionCompany && !this.isBusy && !this.hasFacial
    },

    canLinkDevice() {
      if (this.linkType === 'site') {
        return this.selectedLinkSite !== null && this.selectedLinkSite !== ''
      } else if (this.linkType === 'pos') {
        return this.selectedLinkPos !== null && this.selectedLinkPos !== ''
      }
      return false
    }
  },

  methods: {
    getRecognitionStatusVariant(status) {
      const normalized = (status || '').toString().toLowerCase()
      if (
        normalized.includes('online') ||
        normalized.includes('ativo') ||
        normalized.includes('operacional') ||
        normalized === 'ok' ||
        normalized === 'success'
      ) {
        return 'success'
      }
      if (normalized.includes('alerta') || normalized.includes('warning') || normalized.includes('atenção')) {
        return 'warning'
      }
      return 'danger'
    },
    saveFilters() {
      const filters = {
        selectedOptionCompany: this.selectedOptionCompany,
        selectedOptionSite: this.selectedOptionSite,
        searchTerm: this.searchTerm,
        selectedFilterOption: this.selectedFilterOption,
        currentPage: this.paginationDevices.page,
        perPage: this.perPage,
        tabIndex: this.tabIndex,
        posSearchTerm: this.posSearchTerm,
        facialSearchId: this.facialSearchId,
        facialSearchToken: this.facialSearchToken
      }
      localStorage.setItem('devicesListFilters', JSON.stringify(filters))
    },

    restoreFilters() {
      const savedFilters = localStorage.getItem('devicesListFilters')
      if (savedFilters) {
        try {
          const filters = JSON.parse(savedFilters)
          this.selectedOptionCompany = filters.selectedOptionCompany
          this.selectedOptionSite = filters.selectedOptionSite
          this.searchTerm = filters.searchTerm
          this.selectedFilterOption = filters.selectedFilterOption
          this.paginationDevices.page = filters.currentPage || 1
          this.perPage = filters.perPage
          this.tabIndex = filters.tabIndex
          this.posSearchTerm = filters.posSearchTerm || ''
          this.facialSearchId = filters.facialSearchId || ''
          this.facialSearchToken = filters.facialSearchToken || ''
          return true
        } catch (error) {
          return false
        }
      }
      return false
    },

    clearSavedFilters() {
      localStorage.removeItem('devicesListFilters')
    },

    clearAllFilters() {
      this.selectedOptionCompany = null
      this.selectedOptionSite = null
      this.searchTerm = ''
      this.selectedFilterOption = 1
      this.paginationDevices.page = 1
      this.paginationPos.page = 1
      this.paginationFacial.page = 1
      this.tabIndex = 0
      this.posSearchTerm = ''
      this.facialSearchId = ''
      this.facialSearchToken = ''
      this.clearSavedFilters()
    },

    async clearCompanyFilter() {
      this.selectedOptionCompany = null
      this.paginationDevices.page = 1
      this.paginationPos.page = 1
      this.paginationFacial.page = 1
      this.clearSavedFilters()
      this.clearSiteFilter()
      await this.applyFilter()
    },

    async getCompanies() {
      const url = `${config.default.urlBase}/companies/user`

      try {
        const response = await axios({
          url,
          method: 'get',
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        if (response.status == 200) {
          this.optionsCompany = await Promise.all(
            response.data.map(item => {
              return {
                value: item.id,
                text: item.name
              }
            })
          )

          // if (this.optionsCompany.length == 1 && !this.selectedOptionCompany) {
          //   this.selectedOptionCompany = this.optionsCompany[0].value
          // }
        }
      } catch (error) {
        this.optionsCompany = []
        this.isLoading = false

        if (!error.response) {
          await this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
        }

        if (error.response.status == 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        } else {
          await this.$alert(`Ocorreu um erro ao buscar as empresas! ${error.response.data.message}`, 'Aviso', 'warning')
        }
      }
    },

    async getSitesByCompany(companyId) {
      const url = `${config.default.urlBase}/sites/company/${companyId}`

      try {
        const response = await axios({
          url,
          method: 'get',
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        if (response.status == 200) {
          this.optionsSite = await Promise.all(
            response.data.map(item => {
              return {
                value: item.id,
                text: `${item.id} - ${item.name}`
              }
            })
          )

          if (!this.selectedOptionSite) {
            this.selectedOptionSite = null
          }

          await this.applyFilter()
        }
      } catch (error) {
        this.isLoading = false

        this.sites = []

        if (!error.response) {
          await this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
        }

        if (error.response.status == 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        }
        if (error.response.status == 404) {
          this.getNotification('Aviso', `${error.response.data.message}`, 'warning')
        }
      }
    },

    buildParams(companyId, siteId, searchTerm, selectedFilterOption, page, perPage) {
      const data = {}

      if (companyId) {
        data.companyId = companyId
      }

      if (siteId && siteId !== null && siteId !== undefined) {
        data.siteId = siteId
      }

      if (searchTerm && searchTerm.trim()) {
        if (selectedFilterOption == 1) {
          const deviceId = parseInt(searchTerm.trim())
          if (!isNaN(deviceId)) {
            data.deviceId = deviceId
          }
        } else if (selectedFilterOption == 2) {
          data.deviceName = searchTerm.trim()
        } else if (selectedFilterOption == 3) {
          data.searchTerm = searchTerm.trim()
        }
      }

      data.page = parseInt(page) || 1
      data.pageSize = parseInt(perPage) || 8

      return data
    },

    async getDevices(page) {
      if (!this.selectedOptionCompany) {
        return
      }

      this.isBusy = true
      this.isLoadingData = true

      try {
        const url = `${config.default.urlBase}/site/devices/search`
        const data = this.buildParams(
          this.selectedOptionCompany,
          this.selectedOptionSite,
          this.searchTerm,
          this.selectedFilterOption,
          page,
          this.perPage
        )

        const response = await axios({
          url,
          method: 'POST',
          data,
          headers: { authorization: `Bearer ${this.token}` }
        })

        console.log({ Devices: response })

        if (response.status == 200) {
          this.devices = response.data.items || []
          this.isBusy = false
          this.isLoadingData = false

          this.paginationDevices = {
            ...response.data,
            page: page || 1,
            rowsPerPage: this.perPage,
            paginationRange: this.paginationRange
          }

          this.paginationDevices.page = parseInt(this.paginationDevices.page) || 1
          this.paginationDevices.pages = parseInt(this.paginationDevices.pages) || 1
          this.paginationDevices.records = parseInt(this.paginationDevices.records) || 0

          if (!this.paginationDevices.pages || this.paginationDevices.pages <= 1) {
            this.paginationDevices.pages = Math.ceil(this.paginationDevices.records / this.perPage) || 1
          }

          if (!this.paginationDevices.records || isNaN(this.paginationDevices.records)) {
            this.paginationDevices.records = Array.isArray(this.devices) ? this.devices.length : 0
          }

          await this.fillModels()
        }
      } catch (error) {
        this.devices = []
        this.isBusy = false
        this.isLoadingData = false
        this.isLoading = false

        if (!error.response) {
          await this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
        } else if (error.response.status == 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        }
      }
    },

    async searchPos(page) {
      if (!this.selectedOptionCompany) {
        return
      }

      this.isBusy = true
      try {
        const url = `${config.default.urlBase}/site/pos/search`
        const data = this.buildPosParams(this.selectedOptionCompany, this.selectedOptionSite, page, this.perPage)

        const response = await axios({
          url,
          method: 'POST',
          data,
          headers: { authorization: `Bearer ${this.token}` }
        })

        console.log({ Pos: response })

        if (response.status == 200) {
          this.pos = response.data.items || []
          this.isBusy = false

          this.paginationPos = {
            ...response.data,
            page: page || 1,
            rowsPerPage: this.perPage,
            paginationRange: this.paginationRange
          }

          this.paginationPos.page = parseInt(this.paginationPos.page) || 1
          this.paginationPos.pages = parseInt(this.paginationPos.pages) || 1
          this.paginationPos.records = parseInt(this.paginationPos.records) || 0

          if (!this.paginationPos.records || isNaN(this.paginationPos.records)) {
            this.paginationPos.records = Array.isArray(this.pos) ? this.pos.length : 0
          }

          if (!this.paginationPos.pages || this.paginationPos.pages <= 1) {
            this.paginationPos.pages = Math.ceil(this.paginationPos.records / this.perPage) || 1
          }

          await this.fillModels()
        }
      } catch (error) {
        this.pos = []
        this.isBusy = false
        this.isLoading = false

        if (!error.response) {
          await this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
        }

        if (error.response.status == 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        }
      }
    },

    buildPosParams(companyId, siteId, page, perPage) {
      const data = {}

      if (companyId) {
        data.companyId = companyId
      }

      if (siteId && siteId !== null && siteId !== undefined) {
        data.siteId = siteId
      }

      if (this.posSearchTerm && this.posSearchTerm.trim()) {
        const posNumber = parseInt(this.posSearchTerm.trim())
        if (!isNaN(posNumber)) {
          data.number = posNumber
        }
      }

      data.page = parseInt(page) || 1
      data.pageSize = parseInt(perPage) || 10

      return data
    },

    async getNotification(title, body, type) {
      this.$vToastify.setSettings({
        position: 'bottom-center'
      })
      await this.$vtNotify({
        title: title,
        body: body,
        type: type,
        duration: 3000
      })
    },

    async openModalPos(pos) {
      if (!pos || !pos.id) {
        await this.$alert('Erro ao abrir configurações do POS!', 'Erro', 'error')
        return
      }

      this.posId = pos.id
      this.posNumber = pos.number
      this.sitefParams = pos.varSitefParams || pos.sitefParams || ''
      this.sitefAllowedTransactions = pos.varSitefAllowedTransactions || pos.sitefAllowedTransactions || ''
      this.sitefOtp = pos.varSitefOtp || pos.sitefOtp || ''

      let selectedItem = this.optionSitefLib.find(item => item.text == (pos.varSitefLib || pos.sitefLib))
      this.selectedSitefLib = selectedItem ? selectedItem.value : 0

      this.sitefExternalCom = pos.sitefExternalCom || ''
      this.sitefIsDoubleValidation = pos.sitefIsDoubleValidation || 0
      this.timerInteraction = pos.varSitefTimerInteraction || pos.timerInteraction || 0

      await this.getWeighingMachine()

      let returnSelectedWeighingMachine = this.optionWeighingMachine.find(option => option.id === pos.weighingMachineId)
      this.selectedWeighingMachine = returnSelectedWeighingMachine ? returnSelectedWeighingMachine.value : null

      this.allowEditSitef = false
      this.sitefDailyToken = ''

      if (this.$refs.editPosSite) {
        this.$refs.editPosSite.show()
      }
    },

    async fillModels() {
      this.pos.forEach(item => {
        item.varSitefLib = item.sitefLib
        item.varSitefParams = item.sitefParams
        item.varSitefOtp = item.sitefOtp
        item.varSitefAllowedTransactions = item.sitefAllowedTransactions
        item.varSitefTimerInteraction = item.timerInteraction

        if (item.weighingMachineId && this.optionWeighingMachine.length > 0) {
          const weighingMachine = this.optionWeighingMachine.find(wm => wm.id === item.weighingMachineId)
          if (weighingMachine) {
            item.weighingMachineConfiguration = {
              labelType: weighingMachine.text.split(' - ')[1] || '',
              codSize: weighingMachine.text.split(' - ')[2] || '',
              prefix: weighingMachine.text.split(' - ')[3] || ''
            }
          }
        }
      })
    },

    async applyFilter() {
      if (this.isBusy) return

      this.paginationDevices.page = 1
      this.paginationPos.page = 1
      this.paginationFacial.page = 1

      await this.getDevices(1)
      await this.searchPos(1)
      await this.getRecognitionGateways(1)
      this.saveFilters()
    },

    async applyFilterWithoutSave() {
      if (this.isBusy) return

      await this.getDevices(this.paginationDevices.page)
      await this.searchPos(this.paginationPos.page)
      await this.getRecognitionGateways(this.paginationFacial.page)
    },

    async clearSiteFilter() {
      this.selectedOptionSite = null
      this.paginationDevices.page = 1
      this.paginationPos.page = 1
      this.paginationFacial.page = 1
      this.clearSavedFilters()
      await this.applyFilter()
    },

    async clearSearchFilter() {
      this.searchTerm = ''
      this.paginationDevices.page = 1
      this.paginationPos.page = 1
      this.paginationFacial.page = 1
      this.clearSavedFilters()
      await this.applyFilter()
    },

    editDevice(device) {
      this.saveFilters()
      this.$router.push({
        name: 'DevicesEdit',
        params: {
          siteId: device.siteId,
          siteName: device.siteName,
          companyId: device.companyId,
          companyName: device.companyName,
          deviceId: device.id,
          deviceNumber: device.number,
          page: this.paginationDevices.page,
          pageSize: this.perPage,
          newDevice: 'false',
          deviceDescription: device.description,
          deviceTypeId: device.deviceTypeId,
          deviceType: device.deviceType,
          deviceModelId: device.deviceModelId,
          deviceModel: device.model,
          deviceSerialNumber: device.serialNumber,
          deviceUrlBase: device.urlBase,
          deviceResource: device.resource,
          deviceUser: device.user,
          devicePassword: device.password,
          deviceEwelinkRegion: device.ewelinkRegion,
          deviceExacqResponseVersion: device.exacqResponseVersion,
          deviceIsManualOpeningAllowed: device.isManualOpeningAllowed,
          deviceIsAllowedToMajorEighteen: device.isAllowedToMajorEighteen,
          deviceEwelinkAppId: device.ewelinkAppId,
          deviceEwelinkAppSecret: device.ewelinkAppSecret,
          homeAssistantToken: device.homeAssistantToken,
          homeAssistantAppDaemonUrl: device.homeAssistantAppDaemonUrl,
          homeAssistantEntityId: device.homeAssistantEntityId,
          delayTime: device.delayTime,
          isAllowedToMajorEighteen: device.isAllowedToMajorEighteen,
          isManualOpeningAllowed: device.isManualOpeningAllowed
        }
      })
    },

    newDevice() {
      this.saveFilters()
      const companyId = this.selectedOptionCompany || (this.optionsCompany && this.optionsCompany.length === 1 ? this.optionsCompany[0].value : null)

      this.$router.push({
        name: 'DevicesEdit',
        params: {
          siteId: this.selectedOptionSite,
          companyId: companyId,
          newDevice: 'true',
          returnToLink: 'true'
        }
      })
    },

    redirect(route) {
      this.$router.push(route)
    },

    atualizar() {
      this.applyFilter()
    },

    async openModalDevice(device) {
      this.saveFilters()
      this.editDevice(device)
    },

    showPassword() {
      this.showUserPassword = !this.showUserPassword
    },

    clearWeighingMachine() {
      this.selectedWeighingMachine = null
    },

    async getWeighingMachine() {
      try {
        const url = `${config.default.urlBase}/weighing-machine`
        const response = await axios.get(url, {
          headers: { authorization: `Bearer ${this.token}` }
        })
        this.optionWeighingMachine = response.data.map(item => ({
          id: item.id,
          value: item.id,
          text: `ID: ${item.id} - Tipo: ${item.labelType} - Tamanho Código: ${item.codSize} - Prefixo: ${item.prefix}`
        }))
      } catch (e) {
        this.optionWeighingMachine = []
      }
    },

    async commandPOS(deviceType, device, command) {
      try {
        this.isLoading = true
        const url = `${config.default.urlBaseCustomer}/sites/${deviceType}/command`

        const data = await this.buildDataCommand(deviceType, device, command)

        const response = await axios({
          url,
          method: 'post',
          data,
          headers: { authorization: `Bearer ${this.token}` }
        })

        if (response.status === 200) {
          await this.$alert(`Comando "${command}" enviado com sucesso!`, 'Sucesso', 'success')

          if (deviceType === 'pos') {
            await this.searchPos(this.paginationPos.page)
          } else {
            await this.getDevices(this.paginationDevices.page)
          }
        }
      } catch (error) {
        await this.$alert('Erro ao enviar comando!', 'Erro', 'error')
      } finally {
        this.isLoading = false
      }
    },

    async buildDataCommand(deviceType, device, command) {
      const data = {}

      if (deviceType === 'pos') {
        data.deviceId = device.id
      } else {
        data.recognitionDeviceId = device.id
      }

      data.command = command

      return data
    },

    async triggerDevice(device) {
      try {
        const res = await this.$swal({
          title: 'Confirmar',
          text: 'Deseja realmente acionar este dispositivo?',
          icon: 'warning',
          showCancelButton: true,
          reverseButtons: true,
          confirmButtonColor: '#303030',
          cancelButtonColor: '#fe5c3a',
          confirmButtonText: 'Sim',
          cancelButtonText: 'Não',
          customClass: {
            container: 'swal2-container-high-z'
          }
        })

        if (!res.value) {
          return
        }
        this.isLoading = true

        const url = `${config.default.urlBase}/device/trigger`

        const data = {
          deviceId: device.id,
          posId: device.posId,
          siteId: device.siteId
        }

        await axios.post(url, data, {
          headers: { authorization: `Bearer ${this.token}` }
        })

        await this.$alert('Dispositivo acionado com sucesso!', 'Sucesso', 'success')

        await this.getDevices(this.paginationDevices.page)
      } catch (error) {
        if (!error.response) {
          await this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
        } else if (error.response.status === 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        } else {
          await this.$alert(`Erro ao acionar dispositivo: ${error.response.data?.message || 'Erro desconhecido'}`, 'Erro', 'error')
        }
      } finally {
        this.isLoading = false
      }
    },

    async testDeviceStatus(device) {
      try {
        this.isLoading = true

        const url = `${config.default.urlBase}/device/status`

        const data = {
          entity_id: device.homeAssistantEntityId
        }

        const response = await axios.post(url, data, {
          headers: { authorization: `Bearer ${this.token}` }
        })

        if (response.status === 200) {
          const state = response.data?.status.state === 'on' ? 'aberto' : 'fechado'

          if (state === 'aberto') {
            await this.$alert(`O dispositivo está ${state}`, 'Sucesso', 'success')
          } else {
            await this.$alert(`O dispositivo está ${state}`, 'Aviso', 'warning')
          }
        }

        await this.getDevices(this.paginationDevices.page)
      } catch (error) {
        if (!error.response) {
          await this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
        } else if (error.response.status === 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        } else {
          await this.$alert(`Erro ao testar status do dispositivo: ${error.response.data?.message || 'Erro desconhecido'}`, 'Erro', 'error')
        }
      } finally {
        this.isLoading = false
      }
    },

    cancelPosConfiguration() {
      if (this.$refs.editPosSite) {
        this.$refs.editPosSite.hide()
      }
    },

    async confirmPosConfiguration() {
      this.isLoading = true

      if (!this.posId) {
        await this.$alert('Erro: ID do POS não encontrado!', 'Erro', 'error')
        return
      }

      let weighingMachineId = 0
      if (this.selectedWeighingMachine != null && this.optionWeighingMachine.length > 0) {
        const selectedOption = this.optionWeighingMachine.find(option => option.value === this.selectedWeighingMachine)
        if (selectedOption) {
          weighingMachineId = selectedOption.id
        }
      }

      const posData = this.buildPosData(
        this.posId,
        weighingMachineId,
        this.sitefParams,
        this.selectedSitefLib,
        this.sitefExternalCom,
        this.sitefIsDoubleValidation,
        this.sitefOtp,
        this.sitefAllowedTransactions,
        this.timerInteraction
      )

      try {
        const response = await axios({
          url: `${config.default.urlBase}/sites/pos`,
          method: 'PATCH',
          data: posData,
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        if (response.status == 200) {
          this.isLoading = false

          if (this.$refs.editPosSite) {
            this.$refs.editPosSite.hide()
          }

          await this.$alert('Configuração do POS alterada!', 'Sucesso', 'success')

          await this.applyFilter()
        }
      } catch (error) {
        this.isLoading = false

        if (!error.response) {
          await this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
        }

        if (error.response.status == 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        } else if (error.response.status == 404) {
          this.getNotification('Aviso', `${error.response.data.message}`, 'warning')
        } else {
          this.$alert(`Ocorreu um erro ao alterar as configurações do POS! ${error.response.data.message}`, 'Aviso', 'warning')
        }
      }
    },

    buildPosData(
      posId,
      weighingMachineId,
      sitefParams,
      sitefLib,
      sitefExternalCom,
      sitefIsDoubleValidation,
      sitefOtp,
      sitefAllowedTransactions,
      timerInteraction
    ) {
      let sitefLibText = ''
      if (this.optionSitefLib && Array.isArray(this.optionSitefLib) && this.optionSitefLib.length > 0) {
        const foundOption = this.optionSitefLib.find(opt => opt.value === sitefLib)
        sitefLibText = foundOption ? foundOption.text : ''
      }

      return {
        posId,
        weighingMachineId,
        sitefParams,
        sitefLib: sitefLibText,
        sitefExternalCom,
        sitefIsDoubleValidation: String(sitefIsDoubleValidation),
        sitefOtp,
        sitefAllowedTransactions,
        timerInteraction: timerInteraction ? parseInt(timerInteraction) : 0
      }
    },

    focus(elementId) {
      this.$nextTick(() => {
        const element = document.getElementById(elementId)
        if (element) {
          element.focus()
        }
      })
    },

    lockSitefEdition() {
      this.allowEditSitef = false
      this.sitefDailyToken = ''
    },

    async alloewdEditionSitef() {
      if (this.sitefDailyToken != '') {
        const url = `${config.default.urlBase}/support/daily/token`

        try {
          const response = await axios({
            url,
            method: 'get',
            headers: {
              authorization: `Bearer ${this.token}`
            }
          })

          if (response.status === 200 && response.data) {
            this.DailyToken = response.data.token || response.data.dailyToken || response.data

            if (this.DailyToken === this.sitefDailyToken) {
              this.allowEditSitef = true
            } else if (this.sitefDailyToken !== '') {
              this.allowEditSitef = false
              await this.$alert('Token inválido!', 'Aviso', 'warning')
            }
          }
        } catch (error) {
          this.allowEditSitef = false
          await this.$alert('Erro ao verificar token diário!', 'Erro', 'error')
        }
      } else {
        this.allowEditSitef = false
      }
    },

    showPasswordSitefConfiguration() {
      this.showPasswordSitef = !this.showPasswordSitef

      if (this.showPasswordSitef) {
        this.typeInput = 'text'
      } else {
        this.typeInput = 'password'
      }

      this.focus('sitefDailyToken')
    },

    buildRecognitionData(companyId, siteId, page, perPage) {
      const data = {}

      if (companyId) {
        data.companyId = companyId
      }

      if (siteId && siteId !== null && siteId !== undefined) {
        data.siteId = siteId
      }

      if (this.facialSearchId && this.facialSearchId.trim()) {
        const deviceId = parseInt(this.facialSearchId.trim())
        if (!isNaN(deviceId)) {
          data.recognitionDeviceId = deviceId
        }
      }

      if (this.facialSearchToken && this.facialSearchToken.trim()) {
        data.recognitionToken = this.facialSearchToken.trim()
      }

      data.page = parseInt(page) || 1
      data.pageSize = parseInt(perPage) || 10

      return data
    },

    async getRecognitionGateways(page) {
      console.log('getRecognitionGateways')
      if (!this.selectedOptionCompany) {
        return
      }

      try {
        const url = `${config.default.urlBase}/site/recognition-devices/search`
        const data = this.buildRecognitionData(this.selectedOptionCompany, this.selectedOptionSite, page, this.perPage)

        console.log({ data })

        const response = await axios({
          url,
          method: 'POST',
          data,
          headers: { authorization: `Bearer ${this.token}` }
        })

        console.log({ facial: response })

        if (response.status == 200) {
          this.recognitionGateways = response.data.items || response.data || []

          this.paginationFacial = {
            ...response.data,
            page: page || 1,
            rowsPerPage: this.perPage,
            paginationRange: this.paginationRange
          }

          this.paginationFacial.page = parseInt(this.paginationFacial.page) || 1
          this.paginationFacial.pages = parseInt(this.paginationFacial.pages) || 1
          this.paginationFacial.records = parseInt(this.paginationFacial.records) || 0

          if (!this.paginationFacial.records || isNaN(this.paginationFacial.records)) {
            this.paginationFacial.records = Array.isArray(this.recognitionGateways) ? this.recognitionGateways.length : 0
          }

          if (!this.paginationFacial.pages || this.paginationFacial.pages <= 1) {
            this.paginationFacial.pages = Math.ceil(this.paginationFacial.records / this.perPage) || 1
          }
        }
      } catch (error) {
        this.recognitionGateways = []

        if (error.response && error.response.status == 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        }
      }
    },

    async applyPosFilter() {
      await this.searchPos(this.paginationPos.page)
      this.saveFilters()
    },

    async clearPosSearchFilter() {
      this.posSearchTerm = ''
      this.clearSavedFilters()
      await this.applyPosFilter()
    },

    async applyFacialFilter() {
      await this.getRecognitionGateways(this.paginationFacial.page)
      this.saveFilters()
    },

    async clearFacialIdFilter() {
      this.facialSearchId = ''
      this.clearSavedFilters()
      await this.applyFacialFilter()
    },

    async clearFacialTokenFilter() {
      this.facialSearchToken = ''
      this.clearSavedFilters()
      await this.applyFacialFilter()
    },

    async navigateDevices(page) {
      if (page && page > 0 && page <= this.paginationDevices.pages) {
        this.paginationDevices.page = page
        await this.getDevices(page)
      }
    },

    async navigatePos(page) {
      if (page && page > 0) {
        this.paginationPos.page = page
        await this.searchPos(page)
      }
    },

    async navigateFacial(page) {
      if (page && page > 0) {
        this.paginationFacial.page = page
        await this.getRecognitionGateways(page)
      }
    },

    async openLinkDeviceModal(device) {
      this.deviceToLink = { ...device }
      this.linkType = 'site'
      this.selectedLinkSite = null
      this.selectedLinkPos = null
      this.isLinkModalOpen = true

      if (this.pos.length === 0) {
        await this.searchPos(1)
      }

      this.posOptions = this.pos.map(pos => ({
        value: pos.id,
        text: `POS ${pos.id} - ${pos.token}`
      }))

      if (this.$refs.linkDeviceModal) {
        this.$refs.linkDeviceModal.show()
      }
    },

    async confirmLinkDevice() {
      if (!this.canLinkDevice) {
        return
      }

      if (this.linkType === 'site' && this.deviceToLink.siteId) {
        this.$alert('Este dispositivo já possui vínculo com um site. Remova o vínculo atual primeiro.', 'Aviso', 'warning')
        return
      }

      if (this.linkType === 'pos' && this.deviceToLink.posId) {
        this.$alert('Este dispositivo já possui vínculo com um POS. Remova o vínculo atual primeiro.', 'Aviso', 'warning')
        return
      }

      this.isLoading = true

      try {
        const url = `${config.default.urlBase}/${this.linkType}/devices/link`
        const data = {
          deviceId: this.deviceToLink.id
        }

        if (this.linkType === 'site') {
          data.siteId = this.selectedLinkSite
        } else if (this.linkType === 'pos') {
          data.posId = this.selectedLinkPos
        }

        const response = await axios({
          url,
          method: 'POST',
          data,
          headers: { authorization: `Bearer ${this.token}` }
        })

        if (response.status === 200) {
          if (this.linkType === 'site') {
            this.deviceToLink.siteId = this.selectedLinkSite
            const selectedSite = this.optionsSite.find(site => site.value === this.selectedLinkSite)
            this.deviceToLink.siteName = selectedSite ? selectedSite.text : 'Site'
          } else if (this.linkType === 'pos') {
            this.deviceToLink.posId = this.selectedLinkPos
            const selectedPos = this.posOptions.find(pos => pos.value === this.selectedLinkPos)
            this.deviceToLink.token = selectedPos ? selectedPos.text.split(' - ')[1] : 'POS'
          }

          this.selectedLinkSite = null
          this.selectedLinkPos = null

          this.$alert('Dispositivo vinculado com sucesso!', 'Sucesso', 'success')

          await this.getDevices(this.paginationDevices.page)
        }
      } catch (error) {
        if (!error.response) {
          this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
        } else if (error.response.status === 403) {
          this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        } else {
          this.$alert(`Erro ao vincular dispositivo: ${error.response.data.message}`, 'Erro', 'error')
        }
      } finally {
        this.isLoading = false
      }
    },

    buildDataUnLinkDevice() {
      const data = {}

      if (this.deviceToLink.siteId) {
        data.siteId = this.deviceToLink.siteId
      }

      if (this.deviceToLink.posId) {
        data.posId = this.deviceToLink.posId
      }

      data.deviceId = this.deviceToLink.id
      return data
    },

    async deleteLinkDevice() {
      if (!this.deviceToLink.siteId && !this.deviceToLink.posId) {
        return
      }

      this.isLoading = true

      try {
        const linkType = this.deviceToLink.siteId ? 'site' : 'pos'
        const url = `${config.default.urlBase}/${linkType}/devices/link`
        const data = this.buildDataUnLinkDevice()

        const response = await axios({
          url,
          method: 'DELETE',
          data,
          headers: { authorization: `Bearer ${this.token}` }
        })

        if (response.status === 200) {
          this.isLoading = false
          setTimeout(() => {
            this.$alert('Vínculo removido com sucesso!', 'Sucesso', 'success')
          }, 100)
          await this.getDevices(this.paginationDevices.page)
          this.cancelLinkDevice()
        }
      } catch (error) {
        this.isLoading = false

        if (!error.response) {
          await this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
        } else if (error.response.status === 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        } else {
          await this.$alert(`Erro ao remover vínculo: ${error.response.data.message}`, 'Erro', 'error')
        }
      } finally {
        this.isLoading = false
      }
    },

    async removeSpecificLink(linkType) {
      if (!this.deviceToLink.id) {
        return
      }

      this.isLoading = true

      try {
        const url = `${config.default.urlBase}/${linkType}/devices/link`
        const data = {
          deviceId: this.deviceToLink.id
        }

        if (linkType === 'site') {
          data.siteId = this.deviceToLink.siteId
        } else if (linkType === 'pos') {
          data.posId = this.deviceToLink.posId
        }

        const response = await axios({
          url,
          method: 'DELETE',
          data,
          headers: { authorization: `Bearer ${this.token}` }
        })

        if (response.status === 200) {
          if (linkType === 'site') {
            this.deviceToLink.siteId = null
            this.deviceToLink.siteName = null
          } else if (linkType === 'pos') {
            this.deviceToLink.posId = null
            this.deviceToLink.token = null
          }

          this.selectedLinkSite = null
          this.selectedLinkPos = null

          this.$alert(`Vínculo de ${linkType === 'site' ? 'Site' : 'POS'} removido com sucesso!`, 'Sucesso', 'success')

          await this.getDevices(this.paginationDevices.page)
        }
      } catch (error) {
        if (!error.response) {
          this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
        } else if (error.response.status === 403) {
          this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        } else {
          this.$alert(`Erro ao remover vínculo: ${error.response.data.message}`, 'Erro', 'error')
        }
      } finally {
        this.isLoading = false
      }
    },

    cancelLinkDevice() {
      this.$nextTick(() => {
        if (this.$refs.linkDeviceModal) {
          this.$refs.linkDeviceModal.hide()
        }
        this.isLinkModalOpen = false
      })
    },

    validateSearchInput() {
      if (this.selectedFilterOption === 1) {
        this.searchTerm = this.searchTerm.replace(/[^0-9]/g, '')
      }
    },

    validateKeyPress(event) {
      if (this.selectedFilterOption === 1) {
        const charCode = event.which ? event.which : event.keyCode
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
          event.preventDefault()
        }
      }
    },

    validatePosSearchInput() {
      this.posSearchTerm = this.posSearchTerm.replace(/[^0-9]/g, '')
    },

    validateNumericKeyPress(event) {
      const charCode = event.which ? event.which : event.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        event.preventDefault()
      }
    },

    validateFacialIdInput() {
      this.facialSearchId = this.facialSearchId.replace(/[^0-9]/g, '')
    },

    formatDate(dateString) {
      if (!dateString) return ''

      try {
        const date = new Date(dateString)
        if (isNaN(date.getTime())) return dateString

        return date.toLocaleDateString('pt-BR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        })
      } catch (error) {
        return dateString
      }
    }
  },

  async beforeMount() {
    if (this.isInitializing) return

    this.isInitializing = true
    this.isLoading = true
    this.token = sessionStorage.getItem('token')

    this.paginationDevices = {
      page: 1,
      pages: 1,
      records: 0,
      rowsPerPage: this.perPage,
      paginationRange: this.paginationRange
    }

    this.paginationPos = {
      page: 1,
      pages: 1,
      records: 0,
      rowsPerPage: this.perPage,
      paginationRange: this.paginationRange
    }

    this.paginationFacial = {
      page: 1,
      pages: 1,
      records: 0,
      rowsPerPage: this.perPage,
      paginationRange: this.paginationRange
    }

    const hasHomeParams = this.$route.params.companyId && this.$route.params.siteId
    console.log({ hasHomeParams })

    if (hasHomeParams) {
      this.selectedOptionCompany = this.$route.params.companyId ? this.$route.params.companyId : null
      this.selectedOptionSite = this.$route.params.siteId || null

      this.clearSavedFilters()
    } else {
      this.restoreFilters()
    }

    await this.getCompanies()

    if (hasHomeParams) {
      await this.getSitesByCompany(this.selectedOptionCompany)
      await this.applyFilterWithoutSave()
    } else if (this.selectedOptionCompany) {
      await this.getSitesByCompany(this.selectedOptionCompany)
      await this.applyFilterWithoutSave()
    } else {
      await this.getDevices(this.paginationDevices.page)
    }

    this.tabIndex = 0
    this.isLoading = false
    this.isInitializing = false
  },

  async activated() {
    if (this.isInitializing) return

    const hasNewHomeParams = this.$route.params.companyId && this.$route.params.siteId

    if (hasNewHomeParams) {
      this.selectedOptionCompany = this.$route.params.companyId
      this.selectedOptionSite = this.$route.params.siteId
      this.clearSavedFilters()

      if (!this.optionsSite || this.optionsSite.length === 0) {
        await this.getSitesByCompany(this.selectedOptionCompany)
      }
      await this.applyFilterWithoutSave()
    } else {
      const hasRestoredFilters = this.restoreFilters()
      if (hasRestoredFilters && this.selectedOptionCompany) {
        if (!this.optionsSite || this.optionsSite.length === 0) {
          await this.getSitesByCompany(this.selectedOptionCompany)
        }
        await this.applyFilterWithoutSave()
      }
    }

    const shouldOpenLinkModal = this.$route.params.openLinkModal === 'true'
    if (shouldOpenLinkModal && this.$route.params.deviceId) {
      const deviceId = parseInt(this.$route.params.deviceId)

      await this.$nextTick()

      let device = this.devices.find(d => d.id === deviceId)

      if (!device) {
        await this.getDevices(this.paginationDevices.page)
        await this.$nextTick()
        device = this.devices.find(d => d.id === deviceId)
      }

      if (device) {
        await this.openLinkDeviceModal(device)
      }
    }
  }
}
